export const updateCirclesState = (posX, posY, id) => ({
    type: 'CIRCLES_STATE',
    posX: posX,
    posY: posY,
    id: id
});

export const setCirclesHash = hash => ({
    type: 'SET_CIRCLES_HASH',
    hash: hash
});

export const setCirclesDataWithHash = mata => ({
    type: 'SET_CIRCLES_DATA_WITH_HASH',
    mata: mata
});

export const clearCirclesData = mata => ({
    type: 'CLEAR_CIRCLES_DATA',
    mata: mata
});

const initialState = {
    hash: '',
    type: 'circles',
    data: [
        ['aa', 'aa', 'aa', 'ab', 'ab', 'ab', 'ac', 'ac', 'ac'],
        ['aa', 'aa', 'aa', 'ab', 'ab', 'ab', 'ac', 'ac', 'ac'],
        ['aa', 'aa', 'aa', 'ab', 'ab', 'ab', 'ac', 'ac', 'ac'],
        ['ad', 'ad', 'ad', 'ae', 'ae', 'ae', 'af', 'af', 'af'],
        ['ad', 'ad', 'ad', 'ae', 'ae', 'ae', 'af', 'af', 'af'],
        ['ad', 'ad', 'ad', 'ae', 'ae', 'ae', 'af', 'af', 'af'],
        ['ag', 'ag', 'ag', 'ah', 'ah', 'ah', 'ai', 'ai', 'ai'],
        ['ag', 'ag', 'ag', 'ah', 'ah', 'ah', 'ai', 'ai', 'ai'],
        ['ag', 'ag', 'ag', 'ah', 'ah', 'ah', 'ai', 'ai', 'ai'],
    ],
};

const startingData = [
    ['aa', 'aa', 'aa', 'ab', 'ab', 'ab', 'ac', 'ac', 'ac'],
    ['aa', 'aa', 'aa', 'ab', 'ab', 'ab', 'ac', 'ac', 'ac'],
    ['aa', 'aa', 'aa', 'ab', 'ab', 'ab', 'ac', 'ac', 'ac'],
    ['ad', 'ad', 'ad', 'ae', 'ae', 'ae', 'af', 'af', 'af'],
    ['ad', 'ad', 'ad', 'ae', 'ae', 'ae', 'af', 'af', 'af'],
    ['ad', 'ad', 'ad', 'ae', 'ae', 'ae', 'af', 'af', 'af'],
    ['ag', 'ag', 'ag', 'ah', 'ah', 'ah', 'ai', 'ai', 'ai'],
    ['ag', 'ag', 'ag', 'ah', 'ah', 'ah', 'ai', 'ai', 'ai'],
    ['ag', 'ag', 'ag', 'ah', 'ah', 'ah', 'ai', 'ai', 'ai'],
];

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case 'CIRCLES_STATE':
            if (action.id && !isNaN(action.posX)) {
                if (state.data[action.posX][action.posY] === action.id) {
                    state.data[action.posX][action.posY] = startingData[action.posX][action.posY]
                }
                else state.data[action.posX][action.posY] = action.id;
            }
            break;
        case 'SET_CIRCLES_HASH':
            state.hash = action.hash;
            break;
        case 'SET_CIRCLES_DATA_WITH_HASH':
            return state = Object.assign({}, action.mata.mata);
        case 'CLEAR_CIRCLES_DATA':
            return state = Object.assign({
                data: startingData.map(e => e.concat([])),
                hash: action.mata.hash,
                type: action.mata.type
            });
        default:
            return state;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/state/tableCirclesState.js